interface ICompanyDomainAccessInput {
    clientCanView?: boolean
    querySucceeded: boolean
    queryFetching?: boolean
    queryFailed?: boolean
    queryError?: unknown
    canAttempt?: boolean
}

const getErrorStatus = (error: unknown) => {
    if (typeof error !== 'object' || error === null) return undefined
    const shaped = error as { status?: unknown; response?: { status?: unknown } }
    if (typeof shaped.status === 'number') return shaped.status
    return typeof shaped.response?.status === 'number' ? shaped.response.status : undefined
}

const isForbiddenError = (error: unknown) => {
    if (typeof error !== 'object' || error === null) return false
    return getErrorStatus(error) === 403 || (error as { type?: unknown }).type === 'Forbidden'
}

/** Resolves tab visibility and mutation access from the server-authorized company-domain response. */
export function resolveCompanyDomainAccess({
    clientCanView = false,
    querySucceeded,
    queryFetching = false,
    queryFailed,
    queryError,
    canAttempt = false,
}: ICompanyDomainAccessInput) {
    const forbidden = isForbiddenError(queryError)
    const failed = queryFailed === true || (queryError !== undefined && queryError !== null)
    const showTab = (clientCanView || querySucceeded) && !forbidden
    const mutationsAvailable = querySucceeded && !queryFetching && !failed && !forbidden

    return {
        showTab,
        showRetry: showTab && failed,
        forbidden,
        canManage: mutationsAvailable,
        canAttempt: mutationsAvailable && canAttempt,
    }
}
